export const qrReaderMaskTopBottomHeight = "44px"
export const qrReaderMaskLeftRightWidth = "100px"
